module.exports = __webpack_public_path__ + "media/images/application/template/logo-dc1b16bb257de83ada8a62c22106e66c.svg";